import React from 'react';
import { useSelector } from 'react-redux';
import TrailDashboard from '../TrailDashboard';
import WcaCampaign from '../WCA/WCACampaign';
import Campaigns from '../Campaigns';

const AppCampaign = () => {
  const { userSub, companyConfigData } = useSelector((state) => state.authenticate);
  if (!userSub?.isUserSub) {
    return <TrailDashboard />;
  }

  return companyConfigData?.wabaPartner === 'skalebot' ? <WcaCampaign /> : <Campaigns />;
};

export default AppCampaign;
